import React from 'react';
import '../styles/Multimedia.css';
import mediaImagen from '../assets/images/logo.png';
import mediaGIF from '../assets/images/GIF1.gif';
import mediaSVG from '../assets/images/SVG1.svg';
import mediaVideo from '../assets/videos/video1.mp4';
import mediaAudio from '../assets/audio/audio1.mp3';

function Multimedia() {
    return (
        <div>
            <h2>Multimedia</h2>
            <hr />

            <div>
                {/* Imagenes */}
                <div>
                    <h1>Imágenes</h1>
                    <img src={mediaImagen} alt="Logo" style={{ ...EstiloAqui2, height: "2vw" }} />
                    <h3>GIF</h3>
                    <img src={mediaGIF} alt="Gif Animado" style={{ height: "150px" }} />
                </div>

                {/* Videos */}
                <div>
                    <h1>Videos</h1>
                    <video width="320" height="240" controls>
                        <source src={mediaVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                {/* Audios */}
                <div>
                    <h1>Audios</h1>
                    <audio controls>
                        <source src={mediaAudio} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                </div>

                {/* SVG */}
                <div>
                    <h1>SVG</h1>
                    <img src={mediaSVG} alt="SVG Gráfico" style={{ height: "100px" }} />
                </div>

                {/* Iframe */}
                <div>
                    <h1>Iframe (Contenido externo)</h1>
                    <iframe
                        width="320"
                        height="240"
                        src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                        title="Video en Iframe"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>

                {/* Animación (CSS) */}
                <div>
                    <h1>Animación CSS</h1>
                    <div className="animated-box"></div>
                </div>
            </div>
        </div>
    );
}

const EstiloAqui2 = {
    borderColor: "red",
    borderWidth: "1px",
    borderStyle: "dashed"
};

export default Multimedia;